import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchRecalculateTasksCreate from '../../api/RecalculateTasksCreateAPI';
import { RECALCULATE_TASK_CREATE_REQUEST } from '../actions/types/RecalculateTasksCreateActionsTypes';
import {
  postRecalculateTaskCreateSuccessActionCreator,
  postRecalculateTaskCreateFailureActionCreator,
} from '../actions/RecalculateTasksCreateActions';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';

function* doRecalculateTaskCreateWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchRecalculateTasksCreate, action.payload);
    yield put(postRecalculateTaskCreateSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: res.data.messageKey,
    }));
  } catch (error) {
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.BusinessError.messageKey,
    }));
    yield put(postRecalculateTaskCreateFailureActionCreator(error));
  }
}

function* doRecalculateTaskCreateWatcher() {
  yield takeLatest(RECALCULATE_TASK_CREATE_REQUEST, doRecalculateTaskCreateWorker);
}

export default doRecalculateTaskCreateWatcher;
